import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const BruneiFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14429'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14429)'>
				<rect
					width='20'
					height='14'
					fill='#F7E250'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M-2.97625 2.40322L22.9625 11.6287L23.9544 8.96574L-1.98438 -0.259766L-2.97625 2.40322Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M-3.95477 5.03432L21.984 14.2598L22.9758 11.5968L-2.96289 2.37134L-3.95477 5.03432Z'
					fill='#262626'
				/>
			</g>
		</svg>
	);
};

export default BruneiFlagIcon;
